export default __webpack_public_path__ + "static/media/factory__40.7818d798.jpg";